import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/invisalign/before-after/InvisalignBeforeAfter.tsx");
